import * as React from 'react';

import { connect, Dispatch } from 'react-redux';

import { IAddOnsAppState } from '../../redux-state';
import { IAddOnsAppText } from '../../custom/classes/add-ons-text';
import { IAddOnProduction, IPerformancePricing } from '../../custom/classes/production';
import ListPerformancesView from 'list-addon-performances.view';
import { IPerformanceInfo } from '../../../add-ons/classes/add-ons';
import { getPerformancePricing } from '../../../add-ons/redux-state/actions/add-ons-api.actions';
export interface IListPerformancesExternalProps {
    performanceInfo: IPerformanceInfo;
    productionId: number;
    performancesCount: number;
    hideDate: boolean;
    panelOpen: boolean;
}

interface StateToProps {
}
export type ListProductionsProps = IListPerformancesExternalProps
export type ListProductionsViewProps = ListProductionsProps ;
export class ListPerformancesBase extends React.Component<ListProductionsProps, any> {
    render() {
        return (
            <ListPerformancesView {...this.props}   />
        )
    }
}

function mapStateToProps(state: IAddOnsAppState, ownProps: IListPerformancesExternalProps): StateToProps {
    return {
    }
}

export default connect<StateToProps>(mapStateToProps)(ListPerformancesBase);